module.exports = __webpack_public_path__ + "static/logo-sony-pictures-48cc969be4f4bf52e812fed523335dc0.png";